import MultiDropzone from './MultiDropzone';

export default MultiDropzone;
